import cookieStorage from 'helpers/cookieStorage';

import { UTM_PARAMS } from 'store/consts';

const UTM_PARAM = /utm_\w+/;
const ALLOWED_UTM_PARAMS = /utm_\w+|b2b_special_plan|cross_team_campaign/;
const PREFIXES_TO_REMOVE = /^utm_/;

/**
 * Get allowed utm params from a string.
 * String should be the queryParams from a URL.
 *
 * It is important that this is kept in sync with what we have in the landing-pages project:
 * lib/hooks/useStoreUtmParameters.ts
 *
 */
export const getUtmsParamsFromSearch = (
  search: string,
): Record<string, string> | null => {
  const searchParams = new URLSearchParams(search);
  let utmParams = {};

  searchParams.forEach((value, key) => {
    if (ALLOWED_UTM_PARAMS.test(key)) {
      utmParams = {
        ...utmParams,
        [key.replace(PREFIXES_TO_REMOVE, '')]: value,
      };
    }
  });

  return Object.keys(utmParams).length === 0 ? null : utmParams;
};

export const getUtmParamsFromCookie = () =>
  JSON.parse(cookieStorage.getItem(UTM_PARAMS) || '{}');

const hasUtmParams = (search: string) =>
  Array.from(new URLSearchParams(search).keys()).some((key) =>
    UTM_PARAM.test(key),
  );

const getStoredUtmParams = () => {
  try {
    return getUtmParamsFromCookie() || {};
  } catch {
    return {};
  }
};

export const getUtmParamsToStore = (
  search: string,
): Record<string, string> | null => {
  const utmParams = getUtmsParamsFromSearch(search);

  if (!utmParams) {
    return null;
  }

  return hasUtmParams(search)
    ? utmParams
    : { ...getStoredUtmParams(), ...utmParams };
};
